<div class="insights-page min-full-height-content page-container container-fluid postion-relative">
    <div class="row">
        <div class="insights-card-container col-12 col-xl-12" *claim="claim.ViewReports">
            <top-ten-customers></top-ten-customers>
        </div>
    </div>
</div>
